module.exports = __webpack_public_path__ + "img/Banner-Plantilla-GRANDE-1.8780377c.png";